// ============================================================================
// ENDPOINT GENERATION (no commas, repeated keys for platforms & keywords)
// ============================================================================
export function generateKeywordEndpoint(state: {
  keywords: { main: string[]; additional: string[]; excluded: string[] };
  selectedPlatforms: string[];
  dateRange: string;
  selectedSubFields: string[];
  limit: number;
}): string {
  const baseUrl =
    import.meta.env.VITE_API_BASE_URL || "https://api-staging.metawhale.app";

  const params: string[] = [];

  // 1️⃣ Limit
  params.push(`limit=${encodeURIComponent(state.limit)}`);

  // 2️⃣ Page
  params.push(`page=1`);

  // 3️⃣ Date range
  if (state.dateRange === "last_24_hours") {
    params.push(`last_24_hours=true`);
  } else if (state.dateRange === "last_seven_days") {
    params.push(`last_seven_days=true`);
  } else if (state.dateRange === "last_thirty_days") {
    params.push(`last_thirty_days=true`);
  }

  // 4️⃣ Platforms (repeat key for each platform)
  if (state.selectedPlatforms?.length) {
    state.selectedPlatforms.forEach((platform) => {
      params.push(`platforms=${encodeURIComponent(platform)}`);
    });
  }

  // 5️⃣ Include keywords (repeat key for each keyword)
  if (state.keywords.main?.length) {
    state.keywords.main.forEach((keyword) => {
      params.push(`include_keywords=${encodeURIComponent(keyword)}`);
    });
  }

  // 6️⃣ Additional include keywords (repeat key for each keyword)
  if (state.keywords.additional?.length) {
    state.keywords.additional.forEach((keyword) => {
      params.push(`include_keywords=${encodeURIComponent(keyword)}`);
    });
  }

  // 7️⃣ Exclude keywords (repeat key for each keyword)
  if (state.keywords.excluded?.length) {
    state.keywords.excluded.forEach((keyword) => {
      params.push(`exclude_keywords=${encodeURIComponent(keyword)}`);
    });
  }

  return `${baseUrl}es/posts?${params.join("&")}`;
}

export function generatePostEndpoint(link: string) {
  const baseUrl =
    import.meta.env.VITE_API_BASE_URL || "https://api-staging.metawhale.app";

  if (!link) return "";
  return `${baseUrl}es/post/${encodeURIComponent(link)}`;
}

export function generateInfluencerEndpoint(
  links: string[],
  limit: number = 10,
  page: number = 1,
): string {
  const baseUrl =
    import.meta.env.VITE_API_BASE_URL || "https://api-staging.metawhale.app";

  const params: string[] = [];

  // Add limit and page
  params.push(`limit=${encodeURIComponent(limit)}`);
  params.push(`page=${encodeURIComponent(page)}`);

  // Add each link as a separate links parameter
  if (links && links.length > 0) {
    links.forEach((link) => {
      params.push(`links=${encodeURIComponent(link)}`);
    });
  }

  const cleanBaseUrl = baseUrl.endsWith("/") ? baseUrl.slice(0, -1) : baseUrl;
  const endpoint = `${cleanBaseUrl}/metawhale_v1/influencer/{influencer_link}`;

  return `${endpoint}?${params.join("&")}`;
}
